const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Umunyana: send footer and homepage letters sign-ups straight to Klaviyo (Email List RBrN9x),
   which starts the Welcome series. Shopify's own newsletter post did not pass consent to Klaviyo. */
(function () {
  var LIST = 'RBrN9x';
  var COMPANY = 'Ydd3NB';
  function emailInput(f) { return f.querySelector('input[name="contact[email]"]'); }
  function isNewsletter(f) {
    if (!emailInput(f)) return false;
    var tags = f.querySelector('input[name="contact[tags]"]');
    return (tags && /newsletter/i.test(tags.value)) || f.id === 'ContactFooter' || !!f.closest('#umu-letters-form');
  }
  function show(f, ok) {
    var m = f.querySelector('.umu-signup-msg');
    if (!m) {
      m = document.createElement('p');
      m.className = 'umu-signup-msg';
      m.setAttribute('role', 'status');
      m.style.cssText = 'margin:1.2rem 0 0;text-align:center;line-height:1.4;';
      f.appendChild(m);
    }
    if (ok) {
      m.style.fontFamily = 'var(--font-heading-family)';
      m.style.fontStyle = 'italic';
      m.style.fontSize = '1.7rem';
      m.style.color = '#8A6A2E';
      m.textContent = 'Welcome to Umunyana. Your first letter is on its way.';
    } else {
      m.style.fontFamily = 'var(--font-body-family)';
      m.style.fontStyle = 'normal';
      m.style.fontSize = '1.4rem';
      m.style.color = '#7a2e1f';
      m.textContent = 'Something went wrong. Please try again in a moment.';
    }
    f.querySelectorAll('.newsletter-form__message, .form__message').forEach(function (el) { el.style.display = 'none'; });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !isNewsletter(f)) return;
    e.preventDefault();
    e.stopPropagation();
    var input = emailInput(f);
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
    input.removeAttribute('aria-invalid');
    var btn = f.querySelector('button');
    if (btn) btn.disabled = true;
    var source = f.closest('footer, .footer') ? 'Footer sign-up' : 'Homepage letters sign-up';
    var payload = { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: LIST } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      input.value = '';
      show(f, true);
      if (btn) btn.disabled = false;
    }).catch(function () {
      show(f, false);
      if (btn) btn.disabled = false;
    });
  }, true);
})();
